import '../sass/highlights.scss';

(() => {
    const detailsScript = document.querySelector('#icrav-2027-details-js');
    const swiperScript = document.querySelector('#icrav-2027-swiper-js');
    const $blocks = document.querySelectorAll('.highlights');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $dropdowns = $block.querySelectorAll('.highlights__dropdown');
        const $tabs = $block.querySelectorAll('.highlights__tab');
        const $carousel = $block.querySelector('.highlights__carousel');

        const initDropdowns = () => {
            if (!$dropdowns) return;

            $dropdowns.forEach($dropdown => {
                new Details($dropdown);
            });
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
            });

            if ($tabs) {
                carousel.on('slideChange', () => {
                    $tabs.forEach($tab => {
                        $tab.classList.remove('highlights__tab--active');
                        $tab.removeAttribute('aria-selected');
                    });
                    
                    $tabs[carousel.realIndex].classList.add('highlights__tab--active');
                    $tabs[carousel.realIndex].setAttribute('aria-selected', 'true');
                });

                $tabs.forEach($tab => {
                    $tab.addEventListener('click', e => {
                        e.preventDefault();

                        const { index } = $tab.dataset;

                        carousel.slideTo(index);
                    });
                });
            }
        };

        if (typeof Details !== 'undefined') {
            initDropdowns();
        } else if (detailsScript) {
            detailsScript.addEventListener('load', () => {
                initDropdowns();
            });
        } else {
            window.addEventListener('load', () => {
                if (!detailsScript) return;
                
                detailsScript.addEventListener('load', () => {
                    initDropdowns();
                });
            });
        }

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                if (!swiperScript) return;
                
                swiperScript.addEventListener('load', () => {
                    initCarousel();
                });
            });
        }
    });
})();
